import { AccountResponse } from '@/types/AccountResponse'
import BaseService from './baseService'
import { SearchEngineAuthorization } from '@/types/SearchEngineAuthResponse'
import EndPoints from '@/constants/dxApiEndpoints'

class AccountService extends BaseService {
  async getAccountDetails(
    businessProfileId: number,
    searchEngineTypeId: number = 0
  ): Promise<Array<AccountResponse>> {
    const queryParams = {}
    if (searchEngineTypeId != 0) {
      queryParams.SearchEngineTypeId = searchEngineTypeId
    }
    const respone = await this.apiClient.get<Array<AccountResponse>>(
      EndPoints.AccountDetails(businessProfileId),
      queryParams
    )
    return respone.data
  }

  async createSegmentBpseMapping(
    businessProfileId: number,
    segmentId: number,
    accountIds: Array<number>
  ) {
    await this.apiClient.post(
      EndPoints.SegmentBusinessProfileSearchEngineMapping(
        businessProfileId,
        segmentId
      ),
      accountIds
    )
  }

  async getSearchEngineAuthorizationsDetails(
    businessProfileId: number,
    accountId: number
  ): Promise<SearchEngineAuthorization> {
    const response = await this.apiClient.get(
      EndPoints.SearchEngineAuthDetails(businessProfileId, accountId)
    )
    return response.data
  }

  async getEmbedAccessToken(
    businessProfileId: number,
    accountId: number
  ): Promise<string> {
    const response = await this.apiClient.get(
      EndPoints.GetEmbedAccessToken(businessProfileId, accountId)
    )
    return response.data
  }
}

export default AccountService
